module.exports = __webpack_public_path__ + "static/img/girl-talking-2.b3d826e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatars/girl-talking-2.gif
// module id = 38
// module chunks = 0